import { FormattedMessage, Link } from '@b-stock/fe-core/bstock-react'
import type { DocumentDto } from '@b-stock/listing-api-client'
import { DocumentDtoDocTypeEnum } from '@b-stock/listing-api-client'

import { PageWidthText } from '@/components/PageWidth'

export const StorefrontPolicies = ({
  documents,
}: {
  documents?: DocumentDto[]
}) => {
  const tos = documents?.find(
    ({ docType }) => docType === DocumentDtoDocTypeEnum.TermsOfService
  )

  if (!tos) return null

  return (
    <PageWidthText data-testid="storefront-policies">
      <h2>
        <FormattedMessage id="Storefront.policies.title" />
      </h2>
      <p>
        <FormattedMessage
          id="Storefront.policies.body"
          values={{
            link: (children) => (
              <Link target="_blank" href={tos.url}>
                {children}
              </Link>
            ),
          }}
        />
      </p>
    </PageWidthText>
  )
}
